import { render, staticRenderFns } from "./SjlHotelSyncRule.vue?vue&type=template&id=4f179fdc&scoped=true"
import script from "./SjlHotelSyncRule.vue?vue&type=script&lang=js"
export * from "./SjlHotelSyncRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f179fdc",
  null
  
)

export default component.exports